import { Locale } from "antd/es/locale";
import antDeDE from "antd/lib/locale/de_DE";
import antEnUS from "antd/lib/locale/en_US";
import antEsES from "antd/lib/locale/es_ES";
import antFrFR from "antd/lib/locale/fr_FR";
import antHuHU from "antd/lib/locale/hu_HU";
import antItIT from "antd/lib/locale/it_IT";
import antNlNL from "antd/lib/locale/nl_NL";
import antRoRO from "antd/lib/locale/ro_RO";
import antTrTR from "antd/lib/locale/tr_TR";
import antHrHR from "antd/lib/locale/hr_HR";
import antSrRS from "antd/lib/locale/sr_RS";
import antPlPL from "antd/lib/locale/pl_PL";
import antskSK from "antd/lib/locale/sk_SK";
import antcsCZ from "antd/lib/locale/cs_CZ";
import deDE from "./de-DE.json";
import enUS from "./en-US.json";
import esES from "./es-ES.json";
import frFR from "./fr-FR.json";
import huHU from "./hu-HU.json";
import itIT from "./it-IT.json";
import nlNL from "./nl-NL.json";
import roRO from "./ro-RO.json";
import trTR from "./tr-TR.json";
import hrHR from "./hr-HR.json";
import srRS from "./sr-RS.json";
import plPL from "./pl-PL.json";
import skSK from "./sk-SK.json";
import csCZ from "./cs-CZ.json";

export interface Language {
  translation: {
    meta: {
      languageInEnglish: string;
      languageInNative: string;
    };
  };
}

export const translations: Record<string, Language> = {
  "en-US": enUS,
  "hu-HU": huHU,
  "ro-RO": roRO,
  "de-DE": deDE,
  "es-ES": esES,
  "fr-FR": frFR,
  "it-IT": itIT,
  "nl-NL": nlNL,
  "tr-TR": trTR,
  "hr-HR": hrHR,
  "sr-RS": srRS,
  "pl-PL": plPL,
  "sk-SK": skSK,
  "cs-CZ": csCZ,
};

export const antLocales: Record<string, Locale> = {
  "en-US": antEnUS,
  "hu-HU": antHuHU,
  "ro-RO": antRoRO,
  "de-DE": antDeDE,
  "es-ES": antEsES,
  "fr-FR": antFrFR,
  "it-IT": antItIT,
  "nl-NL": antNlNL,
  "tr-TR": antTrTR,
  "hr-HR": antHrHR,
  "sr-RS": antSrRS,
  "pl-PL": antPlPL,
  "sk-SK": antskSK,
  "cs-CZ": antcsCZ,
};
